import { Skeleton } from "antd";
import { TalentProfile } from "features/settings/types";

export const BioInfo: React.FC<{
  data: TalentProfile["data"] | null;
  isLoading?: boolean;
}> = ({ data, isLoading }) => {
  const renderLink = (url: string | undefined, label: string) => {
    return url ? (
      <h4>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {url}
        </a>
      </h4>
    ) : (
      <h4>{label}</h4>
    );
  };
  return (
    <Skeleton active loading={isLoading}>
      <div className="flex flex-col gap-4">
        {data?.phone &&
          <div>
            <h3 className="text-base font-medium">Phone Number</h3>
            <h4>{data?.phone}</h4>
          </div>
        }
        <div>
          <h3 className="text-base font-medium">Email Address</h3>
          <h4>{data?.email}</h4>
        </div>
        <div>
          <h3 className="text-base font-medium">Gender</h3>
          <h4>{data?.gender}</h4>
        </div>

        {data?.country &&
          <div>
            <h3 className="text-base font-medium">Country</h3>
            <h4>{data?.country}</h4>
          </div>
        }
      
        {data?.city &&
          <div>
            <h3 className="text-base font-medium">City</h3>
            <h4>{data?.city}</h4>
          </div>
        }

        {data?.linkedin &&
          <div>
            <h3 className="text-base font-medium">Linkedin</h3>
            {renderLink(data?.linkedin, "URL not provided")}
          </div>
        }

        {data?.facebook &&
          <div>
            <h3 className="text-base font-medium">Facebook</h3>
            {renderLink(data?.facebook, "URL not provided")}
          </div>
        }

        {data?.x &&
          <div>
            <h3 className="text-base font-medium">x (twitter)</h3>
            {renderLink(data?.x, "URL not provided")}
          </div>
        }

        {data?.github &&
          <div>
            <h3 className="text-base font-medium">Github</h3>
            {renderLink(data?.github, "URL not provided")}
          </div>
        }

        {data?.behance &&
          <div>
            <h3 className="text-base font-medium">Behance</h3>
            {renderLink(data?.behance, "URL not provided")}
          </div>
        }
        {data?.instagram &&
          <div>
            <h3 className="text-base font-medium">Instagram</h3>
            {renderLink(data?.instagram, "URL not provided")}
          </div>
        }

        <div>
          <h3 className="text-base font-medium pb-2">Career Interest</h3>
          <div className="flex flex-wrap items-center gap-2">
            {data?.career_interests.map((item: any) => (
              <button
                key={item.id}
                className="bg-white shadow-sm border rounded px-3 py-1 font-medium"
              >
                {item.name}
              </button>
            ))}
          </div>

        </div>
      </div>
    </Skeleton>
  );
};
